/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['@media (max-width:767px){.library-wrapper[_ngcontent-%COMP%] > span.btn-hj-blue[_ngcontent-%COMP%]{width:100%;margin-bottom:10px}}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9zY3JlZW4tdGFsZW50L3Rlc3Qvc3VtbWFyeS9saWJyYXJ5L2xpYnJhcnkuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ub2RlL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvY2xpZW50L3NjcmVlbi10YWxlbnQvdGVzdC9zdW1tYXJ5L2xpYnJhcnkvbGlicmFyeS5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/client/screen-talent/test/summary/library/library.component.scss.shim.ngstyle.ts